type StatusChipTone = "positive" | "warning" | "neutral";

interface StatusChipProps {
  label: string;
  tone?: StatusChipTone;
}

const toneMap: Record<StatusChipTone, string> = {
  positive: "#77f4c3",
  warning: "#ffcf7d",
  neutral: "#7fd0ff"
};

export function StatusChip({ label, tone = "neutral" }: StatusChipProps) {
  const accent = toneMap[tone];

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 12px",
        borderRadius: "999px",
        background: `${accent}18`,
        border: `1px solid ${accent}3d`,
        color: accent,
        fontSize: "0.76rem",
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        maxWidth: "100%",
        whiteSpace: "normal",
        lineHeight: 1.35
      }}
    >
      {label}
    </span>
  );
}
